import { combineReducers } from 'redux';
import createReducer from "../BasicReducer";

export default combineReducers({
  search: createReducer('activitylog/search', {}),
  list: createReducer('activitylog/list', [])
});